import { Fragment } from "react";

// Components
import InfoHeader from "components/atoms/InfoHeader";

// Constants
import { PRIVACY_LIST } from "constants/info";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";
import { useBreakpoint } from "hooks/useBreakpoint";

const PrivacyInfo = () => {
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();

  const { VITE_APP_PROJECT_NAME } = import.meta.env;

  return (
    <div className="PrivacyInfo">
      {isDesktop ? (
        <InfoHeader title="info.navigation.privacy" />
      ) : (
        <>
          <InfoHeader title="footer.information" />
          <span className="PrivacyInfo__secondTitle">
            {t("info.navigation.privacy").toUpperCase()}
          </span>
        </>
      )}
      {PRIVACY_LIST(VITE_APP_PROJECT_NAME).map((item) => (
        <Fragment key={item.id}>
          {item.header && (
            <span className="PrivacyInfo__title">{t(item.header)}</span>
          )}
          {item.title && (
            <span className="PrivacyInfo__sub-title">{t(item.title)}</span>
          )}
          <span className="PrivacyInfo__description">
            {t(item.description)}
          </span>
        </Fragment>
      ))}
    </div>
  );
};

export default PrivacyInfo;
